/**
 * @param {Object}    options
 * @param {Number?}   options.max_all Maximum total amount of all categories. By default, it is 9.
 * @param {Number?}   options.min_all Minimum total amount of all categories. By default, it is 1.
 * @param {Number?}   options.min_category Minimum amount of each category. By default, it is 0.
 * @param {jQuery}    options.$wrapper Custom jQuery object to attach instance.
 *
 * @param {Function?} options.onChange(that, category, value, count) Callback, which will be called when any category value is changed.
 *                                           Arguments: `category` - code of changed category;
 *                                                      `value` - new value of changed category;
 *                                                      `count` - summ of all active categories after that category changed.
 *
 * @param {Function?} options.onSubsidyChange(value) Callback, which will be called when subsidy value is changed.
 *                                           Arguments: `value` - new subsidy value.
 *
 * @param {Function?} options.onSubmit(instance, data, count) Callback, which will be called when mobile picker was submitted.
 *                                           Arguments: `instance` - instance of mobile UIPassengerCategoriesPicker;
 *                                                      `data` - collected picker values;
 *                                                      `count` - summ of all active categories after submit.
 */
var UIPassengerCategoriesPicker = (function ($) {

    UIPassengerCategoriesPicker = function (options) {
        var that = this;
        
        // CONST
        that.MAX_ALL = options['max_all'] || 9;
        that.MIN_ALL = options['min_all'] || 1;
        that.MIN_CATEGORY = options['min_category'] || 0;
        that.CATEGORIES = {
            default: {
                // first order
                first: {
                    with_subsidy: 'SRC',
                    without_subsidy: 'ADT'
                },
                // second order
                second: {
                    with_subsidy: 'YTH',
                    without_subsidy: 'ADT' // without subsidy always set ADT
                }
            },
            need_accompanying: [
                'INS',
                'INF'
            ],
            accompanying: [
                'ADT',
                'SRC',
                'YTH'
            ],
            subsidy: {
                show_with: [
                    'SRC',
                    'YTH'
                ],
                show_without: [
                    'ADT',
                    'INS'
                ]
            }
        };

        that.class = {
            category_hidden: 'hidden',
            subsidy_hidden: 'hidden',
        };

        that.selectors = {
            picker: '.js-passenger-categories-picker',
            category: '.js-passenger-categories-item',
            category_counter: '.js-passenger-categories-item-counter',
            category_input: '.js-counter-input',
            settings: '.js-passenger-categories-settings',
            subsidy_checkbox: '.js-passenger-categories-subsidy-checkbox'
        };

        that.data_keys = {
            picker_categories: 'categories',
            category_code: 'code',
            counter_category_code: 'code'
        };
        
        // DOM
        that.$picker = options['$wrapper'] ? options['$wrapper'] : $.sa.$document.find(that.selectors.picker);
        that.$categories = that.$picker.find(that.selectors.category);
        that.$settings = that.$picker.find(that.selectors.settings);
        that.$subsidy_checkbox = that.$settings.find(that.selectors.subsidy_checkbox);

        that.onChange = (options['onChange'] || function () {});
        that.onSubsidyChange = (options['onSubsidyChange'] || function () {});
        that.onSubmit = (options['onSubmit'] || function () {});

        // INIT
        that.init();
    };

    UIPassengerCategoriesPicker.prototype.custom_events = {
        category_value_changed: 'category_value_changed'
    };

    UIPassengerCategoriesPicker.prototype.init = function () {
        var that = this;

        that.initEventHandlers();
    };

    UIPassengerCategoriesPicker.prototype.initEventHandlers = function () {
        var that = this;

        that.$picker.on(UICounter.prototype.custom_events.value_changed_manually, that.selectors.category_counter, function (e, new_value) {
            var $category_counter = $(this),
                code = $category_counter.data(that.data_keys.counter_category_code);
            that.set(code, new_value);
        });

        that.$picker.on('click', that.selectors.subsidy_checkbox, function (e) {
            var value = that.$subsidy_checkbox.is(':checked');
            that.setSubsidyValue(value, !value);
        });
    };

    UIPassengerCategoriesPicker.prototype.count = function () {
        var that = this,
            $categories = that._getActiveCategories(),
            $categories_inputs = $categories.find(that.selectors.category_input),
            count = 0;
        
        $categories_inputs.each(function () {
            var $input = $(this),
                value = parseInt($input.val(), 10) || 0;

            count += value;
        });
        
        return count;
    };

    /**
     * @param {string[]?} categories
     * @return {Object}
     */
    UIPassengerCategoriesPicker.prototype.collectCategoryValues = function (categories = null) {
        var that = this,
            $categories = (categories && categories.length) ? that.getCategories(categories) : that.$categories,
            values = {};

        $categories.find(that.selectors.category_counter).each(function() {
            var $counter = $(this),
                $count_input = $counter.find(that.selectors.category_input),
                code  = $counter.data(that.data_keys.counter_category_code);

            values[code] = parseInt($count_input.val(), 10);
        });

        return values;
    };

    UIPassengerCategoriesPicker.prototype.collect = function () {
        var that = this;

        return {
            category: that.collectCategoryValues(),
            subsidy: {
                has: that.isSubsidyHas(),
                value: that.isSubsidyEnabled()
            }
        };
    };

    /**
     * Returns object of all categories and values:
     * if category is active, collecting its value, otherwise - collecting MIN_CATEGORY instead of its value
     * (just for SearchForm use, to build search_params - search_params needs to grab all categories, but do not grab ADT as 1 if it's inactive)
     *
     * @return {Object}
     */
    UIPassengerCategoriesPicker.prototype.collectActiveValuesOfAllCategories = function () {
        var that = this,
            inactive_category_codes = that._getInactiveCategoryCodes(),
            values = that.collectCategoryValues();

        inactive_category_codes.forEach(function (code) {
            if (values.hasOwnProperty(code)) {
                values[code] = that.MIN_CATEGORY;
            }
        });

        return values;
    };

    UIPassengerCategoriesPicker.prototype.getAllCategoryCodes = function () {
        var that = this,
            codes = that.$picker.data(that.data_keys.picker_categories) || []; // cache all codes in data-attr

        if (codes && codes.length) {
            return codes;
        }

        that.$categories.each(function () {
            codes.push($(this).data(that.data_keys.category_code));
        });

        return codes;
    };

    UIPassengerCategoriesPicker.prototype.set = function (category, value) {
        var that = this,
            count = that.count(),
            count_accompanying = that._countAccompanying(),
            need_accompanying_max_value = that._getNeedAccompanyingMax(),
            categories_to_update = {}; // order to set values is not important - because we use only `_set()`

        // ==== COLLECTING VALUES TO UPDATE ====

        setToUpdate(category, value);

        if (that._isCategoryAccompanying(category)) {
            // if category is accompanying, and no other accompanying left
            if (count_accompanying === that.MIN_CATEGORY) {
                if (count >= that.MIN_ALL) { // condition to not duplicate logic below
                    // set default category (WARNING: DEFAULT CATEGORY MUST BE ACCOMPANYING, otherwise - change logic below)
                    if (that._isCategoryDefaultFirst(category)) {
                        setToUpdate(that._getDefault('second'), that.MIN_ALL);
                    } else {
                        setToUpdate(that._getDefault('first'), that.MIN_ALL);
                    }
                }
            }
            // if category is accompanying, and needing accompanying categories are greater than accompanying ones
            // reduce needing accompanying categories to the count of accompanying categories
            else if (count_accompanying < need_accompanying_max_value) {
                for (let category_code of that.CATEGORIES.need_accompanying) {
                    let category_value = that.getCategoryValue(category_code);
                    // if value is greater than accompanying categories count, reduce value
                    if (category_value > count_accompanying) {
                        setToUpdate(category_code, count_accompanying);
                    }
                }
            }
        }

        // if category dropped, and no other categories left
        if (value === that.MIN_CATEGORY && count < that.MIN_ALL) {
            // if category was default, set another default category
            if (that._isCategoryDefaultFirst(category)) {
                setToUpdate(that._getDefault('second'), that.MIN_ALL);
            } else {
                setToUpdate(that._getDefault('first'), that.MIN_ALL);
            }
        }

        // ==== UPDATE VALUES AND MAX ====

        that._setMany(categories_to_update, true); // active_only - to prevent updating max for hidden categories
        
        // ==== END ====

        function setToUpdate (category, value) {
            var value_prev = that.getCategoryValue(category),
                value_diff = value - value_prev;

            categories_to_update[category] = value;

            count += value_diff;

            // if accompanying was increased, increase max for needing accompanying categories
            if (that._isCategoryAccompanying(category)) {
                count_accompanying += value_diff;
            }
        }
    };

    UIPassengerCategoriesPicker.prototype._set = function (category, value, check_limits = true) {
        var that = this,
            $category_counter = that.$picker.find(that.selectors.category_counter + '[data-' + that.data_keys.counter_category_code + '="' + category + '"]'),
            count;

        try {
            UICounter.prototype.set($category_counter, value, check_limits);
        } catch (e) {
            $.sa.error(e);
        }

        count = that.count();

        // trigger event
        // pass summ of current categoires with event data
        that.$picker.trigger(that.custom_events.category_value_changed, count);

        that.onChange(that, category, value, count);
    };

    UIPassengerCategoriesPicker.prototype.setDefault = function (subsidy_enabled = false) {
        var that = this,
            category_code = subsidy_enabled
                ? that.CATEGORIES.default.first.with_subsidy
                : that.CATEGORIES.default.first.without_subsidy;

        that.set(category_code, that.MIN_ALL);
    };

    UIPassengerCategoriesPicker.prototype._setMax = function (category, max) {
        var that = this,
            $category_counter = that.$picker.find(that.selectors.category_counter + '[data-' + that.data_keys.counter_category_code + '="' + category + '"]');

        if (!$category_counter.length) {
            $.sa.log('UIPassengerCategoriesPicker::_setMax() / Not found category counter', category);
            return;
        }

        UICounter.prototype.setMax($category_counter, max);
    };

    UIPassengerCategoriesPicker.prototype.setSubsidyValue = function (value, value_previous = null) {
        value = !!value;

        var that = this,
            categories_to_show = value ? that.CATEGORIES.subsidy.show_with : that.CATEGORIES.subsidy.show_without,
            categories_to_hide = value ? that.CATEGORIES.subsidy.show_without : that.CATEGORIES.subsidy.show_with;

        if (null === value_previous) {
            value_previous = that.isSubsidyEnabled();
        } else if (typeof value_previous !== 'boolean') {
            value_previous = !!value_previous;
        }

        // if new value is the same as current, do nothing
        if (value_previous === value) {
            return;
        }

        // set value to control
        that._setSubsidyValue(value);

        // show categories
        categories_to_show.forEach(function (category) {
            that._categoryShow(category);
        });

        // hide categories
        categories_to_hide.forEach(function (category) {
            that._categoryHide(category);
        });

        // drop all categories
        that.reset();

        that.set(
            value
                ? that.CATEGORIES.default.first.with_subsidy
                : that.CATEGORIES.default.first.without_subsidy,
            that.MIN_ALL
        );

        that.onSubsidyChange(value);
    };

    UIPassengerCategoriesPicker.prototype._setSubsidyValue = function (value) {
        var that = this;
        that.$subsidy_checkbox.prop('checked', value);
    };

    UIPassengerCategoriesPicker.prototype.setSubsidyHas = function (has) {
        var that = this,
            has_current = that.isSubsidyHas(),
            value_current = that.isSubsidyEnabled();

        has = !!has;

        // if new `has` is the same as current, do nothing
        if (has_current === has) {
            return;
        }

        // if subsidy is not available - set subsidy false automatically (in case value is not already `false`)
        if (value_current !== false && has === false) {
            that.setSubsidyValue(false);
        }

        // show/hide subsidy
        if (has) {
            that._enableSubsidy();
        } else {
            that._disableSubsidy();
        }
    };

    UIPassengerCategoriesPicker.prototype.setAll = function (data) {
        var that = this;

        if (
            !data.hasOwnProperty('category') &&
            !data.hasOwnProperty('subsidy')
        ) {
            return;
        }

        var categories = data.category || {},
            subsidy = data.subsidy || {},
            subsidy_has = subsidy.hasOwnProperty('has') ? subsidy.has : false,
            subsidy_value = subsidy.hasOwnProperty('value') ? subsidy.value : false,
            count = 0,
            count_need_accompanying = 0,
            count_accompanying = 0,
            need_accompanying_max_value = 0;

        // ==== RESET ALL VALUES ====

        that.reset();

        // ==== PREPARE VALUES ====

        for (let category_code in categories) {
            let category_value = parseInt(categories[category_code], 10),
                category_min = that._getCategoryMin(category_code);

            if (category_value < category_min) {
                category_value = category_min;
            }

            count += category_value;

            if (that._isCategoryAccompanying(category_code)) {
                count_accompanying += category_value;
            }

            if (that._isCategoryNeedAccompanying(category_code)) {
                count_need_accompanying += category_value;

                if (category_value > need_accompanying_max_value) {
                    need_accompanying_max_value = category_value;
                }
            }

            // if any subsidy category is non-empty - set `subsidy_value` as `true` and `subsidy_has` as `true`
            if (that._isCategorySubsidy(category_code) && category_value > that.MIN_CATEGORY) {
                subsidy_has = true;
                subsidy_value = true;
            }
        }

        // if count is lesser than minimum,
        // or count of accompanying categories is lesser than minimum -
        // set default category (WARNING: DEFAULT CATEGORY MUST BE ACCOMPANYING, otherwise - change logic below)
        if (count < that.MIN_ALL || count_accompanying < that.MIN_ALL) {
            if (subsidy_value) {
                update(that.CATEGORIES.default.first.with_subsidy, that.MIN_ALL);
            } else {
                update(that.CATEGORIES.default.first.without_subsidy, that.MIN_ALL);
            }
        }

        // if needing accompanying categories are greater than accompanying ones -
        // reduce needing accompanying categories to the count of accompanying categories
        if (count_accompanying < need_accompanying_max_value) {
            for (let category_code in categories) {
                if (!that._isCategoryNeedAccompanying(category_code)) {
                    continue;
                }

                let category_value = parseInt(categories[category_code], 10);

                // if value is greater than accompanying categories count, reduce value
                if (category_value > count_accompanying) {
                    update(category_code, count_accompanying);
                }
            }
        }

        // ==== SET SUBSIDY ====

        that.setSubsidyValue(subsidy_value);

        that.setSubsidyHas(subsidy_has);

        // ==== SET VALUES AND MAX ====

        that._setMany(categories);

        // ==== END ====

        function update (category, value) {
            let prev_value = categories[category] || 0,
                value_diff = value - prev_value;

            if (value_diff === 0) {
                return;
            }

            categories[category] = value;
            count += value_diff;

            if (that._isCategoryAccompanying(category)) {
                count_accompanying += value_diff;
            }
            if (that._isCategoryNeedAccompanying(category)) {
                count_need_accompanying += value_diff;
            }
        }
    };

    /**
     * Set values to multiple categories.
     * @param {Object} categories_values Format: `{category_code: new_value}`
     * @param {boolean} active_only Which of related categories must be updated: only active ones, or everyone.
     * @private
     */
    UIPassengerCategoriesPicker.prototype._setMany = function (categories_values, active_only = false) {
        var that = this,
            $categories_to_update = active_only ? that._getActiveCategories() : that.$categories,
            categories_codes = that.getCategoriesCodes($categories_to_update),
            count = 0,
            count_accompanying = 0,
            max_new;

        // ==== COUNT NEW VALUES ====

        categories_codes.forEach(function (category_code) {
            let category_value = categories_values.hasOwnProperty(category_code)
                    ? parseInt(categories_values[category_code], 10)
                    : (that.getCategoryValue(category_code) || that._getCategoryMin(category_code));

            count += category_value;
            if (that._isCategoryAccompanying(category_code)) {
                count_accompanying += category_value;
            }
        });

        max_new = that.MAX_ALL - count;

        // ==== UPDATE MAX TO ALL CATEGORIES ====

        $categories_to_update.each(function () {
            let $category = $(this),
                category_code = $category.data(that.data_keys.category_code),
                category_value = categories_values.hasOwnProperty(category_code)
                    ? parseInt(categories_values[category_code], 10)
                    : (that.getCategoryValue(category_code) || that._getCategoryMin(category_code)),
                category_max_new = max_new + category_value,
                is_need_accompanying = that._isCategoryNeedAccompanying(category_code);

            // if category is need accompanying - set accompanying count or max_new as max
            if (is_need_accompanying) {
                that._setMax(category_code, Math.min(category_max_new, count_accompanying));
            }
            // otherwise - set max_new as max
            else {
                that._setMax(category_code, category_max_new);
            }
        });

        // ==== SET VALUES ====

        for (let category_code in categories_values) {
            that._set(category_code, categories_values[category_code]);
        }
    };

    UIPassengerCategoriesPicker.prototype.reset = function () {
        var that = this,
            categories_codes_all = that.getAllCategoryCodes();

        that._setMany(
            // build object, containing all existing categories codes as keys, and min value of each category as values
            categories_codes_all.reduce(function(res, code) {
                res[code] = that._getCategoryMin(code);
                return res;
            }, {})
        );
    };

    UIPassengerCategoriesPicker.prototype.getCategory = function (category) {
        var that = this;
        return that.$categories.filter('[data-' + that.data_keys.category_code + '="' + category + '"]');
    };

    UIPassengerCategoriesPicker.prototype.getCategories = function (categories) {
        var that = this;

        if (!Array.isArray(categories)) {
            $.sa.error('UIPassengerCategoriesPicker.getCategories(): invalid argument');
            return null;
        }

        return that.$categories.filter(
            function () {
                var category_code = $(this).data(that.data_keys.category_code);
                return categories.includes(category_code);
            }
        );
    };

    UIPassengerCategoriesPicker.prototype.getCategoryValue = function (category) {
        var that = this,
            $category = that.getCategory(category),
            values = that.getCategoriesValues($category);
        return values[category];
    };

    UIPassengerCategoriesPicker.prototype.getCategoriesValues = function ($categories) {
        var that = this,
            values = {};
        
        $categories.each(function () {
            var $category = $(this),
                code = $category.data(that.data_keys.category_code),
                $category_input = $category.find(that.selectors.category_input),
                value = $category_input.val();
            values[code] = parseInt(value, 10);
        });

        return values;
    };

    UIPassengerCategoriesPicker.prototype.getCategoriesCodes = function ($categories) {
        var that = this,
            codes = [];

        $categories.each(function () {
            var $category = $(this),
                code = $category.data(that.data_keys.category_code);

            codes.push(code);
        });

        return codes;
    };

    UIPassengerCategoriesPicker.prototype.isSubsidyHas = function () {
        var that = this;
        return !that.$settings.hasClass(that.class.subsidy_hidden);
    };

    UIPassengerCategoriesPicker.prototype.isSubsidyEnabled = function () {
        var that = this;

        if (!that.isSubsidyHas()) {
            return false;
        }

        return !!that.$subsidy_checkbox.prop('checked');
    };

    UIPassengerCategoriesPicker.prototype._enableSubsidy = function () {
        var that = this;
        that.$settings.removeClass(that.class.subsidy_hidden);
    };

    UIPassengerCategoriesPicker.prototype._disableSubsidy = function () {
        var that = this;
        that.$settings.addClass(that.class.subsidy_hidden);
    };

    UIPassengerCategoriesPicker.prototype._categoryShow = function (category) {
        var that = this,
            $category = that.getCategory(category);
        $category.removeClass(that.class.category_hidden);
    };

    UIPassengerCategoriesPicker.prototype._categoryHide = function (category) {
        var that = this,
            $category = that.getCategory(category);
        $category.addClass(that.class.category_hidden);
    };

    UIPassengerCategoriesPicker.prototype._isCategoryHidden = function (category) {
        var that = this,
            $category = that.getCategory(category);
        return that._isHidden($category);
    };

    UIPassengerCategoriesPicker.prototype._isHidden = function ($category) {
        var that = this;
        return $category.hasClass(that.class.category_hidden);
    };

    UIPassengerCategoriesPicker.prototype._getCategoryMin = function (category) {
        var that = this,
            $category = that.getCategory(category),
            $category_counter = $category.find(that.selectors.category_counter);

        return UICounter.prototype.getMin($category_counter);
    };

    UIPassengerCategoriesPicker.prototype._getDefault = function (order = 'first') {
        var that = this,
            subsidy = that.isSubsidyEnabled();

        if (order === 'first') {
            return subsidy
                ? that.CATEGORIES.default.first.with_subsidy
                : that.CATEGORIES.default.first.without_subsidy;
        }

        if (order === 'second') {
            return subsidy
                ? that.CATEGORIES.default.second.with_subsidy
                : that.CATEGORIES.default.second.without_subsidy;
        }

        if (
            that.CATEGORIES.default.hasOwnProperty(order) &&
            typeof that.CATEGORIES.default[order] === 'string'
        ) {
            return that.CATEGORIES.default[order];
        }

        $.sa.error(`UIPassengerCategoriesPicker::_getDefault(): invalid value of argument "order": "${order}"`);
        return null;
    };

    UIPassengerCategoriesPicker.prototype._isCategoryDefaultFirst = function (category) {
        var that = this;
        return that.CATEGORIES.default.first.with_subsidy === category ||
               that.CATEGORIES.default.first.without_subsidy === category;
    };

    UIPassengerCategoriesPicker.prototype._getActiveCategories = function () {
        var that = this;
        return that.$categories.not('.' + that.class.category_hidden);
    };

    UIPassengerCategoriesPicker.prototype._getInactiveCategories = function () {
        var that = this;
        return that.$categories.filter('.' + that.class.category_hidden);
    };

    UIPassengerCategoriesPicker.prototype._getActiveCategoryCodes = function () {
        var that = this,
            $categories = that._getActiveCategories();
        return that.getCategoriesCodes($categories);
    };

    UIPassengerCategoriesPicker.prototype._getInactiveCategoryCodes = function () {
        var that = this,
            $categories = that._getInactiveCategories();
        return that.getCategoriesCodes($categories);
    };

    UIPassengerCategoriesPicker.prototype._isCategoryNeedAccompanying = function (category) {
        var that = this;
        return that.CATEGORIES.need_accompanying.includes(category);
    };

    UIPassengerCategoriesPicker.prototype._isCategoryAccompanying = function (category) {
        var that = this;
        return that.CATEGORIES.accompanying.includes(category);
    };

    UIPassengerCategoriesPicker.prototype._isCategorySubsidy = function (category) {
        var that = this;
        return that.CATEGORIES.subsidy.show_with.includes(category);
    };

    UIPassengerCategoriesPicker.prototype._countAccompanying = function () {
        var that = this,
            $active_categories = that._getActiveCategories(),
            $active_accompanying_categories = $active_categories.filter(function () {
                var $category = $(this),
                    category_code = $category.data(that.data_keys.category_code);
                return that.CATEGORIES.accompanying.includes(category_code);
            }),
            values = that.getCategoriesValues($active_accompanying_categories),
            count = 0;

        for (let category_code in values) {
            count += values[category_code];
        }

        return count;
    };

    UIPassengerCategoriesPicker.prototype._countNeedAccompanying = function () {
        var that = this,
            $active_categories = that._getActiveCategories(),
            $active_need_accompanying_categories = $active_categories.filter(function () {
                var $category = $(this),
                    category_code = $category.data(that.data_keys.category_code);
                return that.CATEGORIES.need_accompanying.includes(category_code);
            }),
            values = that.getCategoriesValues($active_need_accompanying_categories),
            count = 0;

        for (let category_code in values) {
            count += values[category_code];
        }

        return count;
    };

    /**
     * Get maximal value of all needing accompanying categories
     * @return {number}
     * @private
     */
    UIPassengerCategoriesPicker.prototype._getNeedAccompanyingMax = function () {
        var that = this,
            values = that.getCategoriesValues(that.getCategories(that.CATEGORIES.need_accompanying)),
            max = 0;

        for (let category_code in values) {
            if (values[category_code] > max) {
                max = values[category_code];
            }
        }

        return max;
    };

    UIPassengerCategoriesPicker.prototype.initMobile = function (picker_options, view_options = {}) {
        var that = this,
            $picker = picker_options['$wrapper'];

        if (!$picker) {
            return null;
        }

        var $content = $('<div />').addClass('passenger-categories-picker-drawer-content');

        $content.append($picker);

        var instance = new UIPassengerCategoriesPicker(picker_options);

        setTimeout(function () {
            $.uiDrawer(Object.assign({}, {
                position: 'bottom',
                fluid: true,
                disable_content_scroll: true,
                mobile_fullscreen: true,
                custom_class: 'passenger-categories-picker-drawer',
                content: $content,
                button_confirm_text: $.sa.locales['continue'],
                onButtonConfirmClick: function (drawer, event) {
                    instance.onSubmit(instance, instance.collect(), instance.count());
                }
            }, view_options));
        }, 0);

        return instance;
    };

    return UIPassengerCategoriesPicker;
})($);